export const infoLight = "#03a9f4";

export const lightBlue = "#bbdefb";
